import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

/**
 * Breadcrumb shown on the block/asset create & edit pages when the user arrived
 * from the Operation Overview flow (via `?from=operation&farmId=&farmName=`).
 * Lets them step back to the farm hub or the overview without losing context.
 * Rendered only by the host (behind an *ngIf on the `from` query param), so it
 * never appears for the pages' other entry points.
 */
@Component({
  selector: 'kw-operation-breadcrumb',
  template: `
    <nav class="op-crumbs" aria-label="Breadcrumb">
      <a (click)="go('harvest-engine/core/operation-overview')">Operation Overview</a>
      <ng-container *ngIf="farmId">
        <span class="sep">/</span>
        <a (click)="go('harvest-engine/core/operation-overview/farm/' + farmId)">{{ farmName || 'Farm' }}</a>
      </ng-container>
      <span class="sep">/</span>
      <span class="here">{{ leafLabel }}</span>
    </nav>
  `,
  styles: [`
    .op-crumbs { display: flex; align-items: center; flex-wrap: wrap; gap: 8px; font-size: 13px; color: #64748b; margin-bottom: 14px; }
    .op-crumbs a { color: #253d5b; font-weight: 600; cursor: pointer; }
    .op-crumbs a:hover { text-decoration: underline; }
    .op-crumbs .sep { color: #94a3b8; }
    .op-crumbs .here { color: #17212e; font-weight: 600; }
  `]
})
export class OperationBreadcrumbComponent {
  @Input() farmId: number;
  @Input() farmName: string;
  @Input() leafLabel: string;

  constructor(private router: Router) {}

  go(url: string): void {
    this.router.navigateByUrl(url);
  }
}
